import React from "react";

/** Spacing the page never shows, e.g. the trailing space in "Screener ". */
const asDisplayed = (value: string) =>
  (value ?? "").replace(/\s+/g, " ").trim();

/**
 * Wraps one of a pair's two values in a highlight when it differs from the
 * other, so the fields where the payments disagree stand out. Values are
 * compared as displayed, so two values that read the same are never flagged.
 */
const PairValue: React.FC<{
  value: string;
  other: string;
  children?: React.ReactNode;
}> = ({ value, other, children }) =>
  asDisplayed(value) !== asDisplayed(other) ? (
    <mark className="overlap-diff" title="Differs from the other payment">
      {children ?? value}
    </mark>
  ) : (
    <>{children ?? value}</>
  );

export default PairValue;
